import {Collapse, IconButton, Typography} from '@mui/material';
import Paper from '@mui/material/Paper';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import classNames from 'classnames';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {useToggle} from 'common/hooks/useToggle';

type PanelProps = {
   root?: boolean;
   name?: string;
   className?: string;
   style?: React.CSSProperties;
   children: React.ReactNode;
   marginTop?: number;
   open?: boolean;
};

const useStyles = makeStyles((theme) => ({
   root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      position: 'relative',
      borderColor: theme.palette.primary.main,
      marginTop: ({marginTop = 1}: {marginTop?: number}) => theme.spacing(marginTop),
   },
   name: {
      ...theme.typography.caption,
      position: 'absolute',
      top: '-9px',
      left: '64px',
      backgroundColor: theme.palette.background.paper,
      padding: '0 3px',
   },
   rootPanel: {
      fontWeight: 'bold',
      fontSize: '1rem',
      top: '-11px',
   },
   expandButton: {
      top: '-24px',
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary.main,
      // right: '1rem',
      '&:hover': {
         backgroundColor: theme.palette.background.paper,
      },
   },
}));

const CollapsiblePanel = ({
   root,
   name,
   className,
   children,
   style,
   marginTop,
   open,
}: PanelProps) => {
   const classes = useStyles({marginTop});
   const [advanceExpanded, toggle] = useToggle(open);
   return (
      <Paper className={classNames(classes.root, className)} style={style} variant="outlined">
         {name ? (
            <Typography
               color="primary"
               variant={'inherit'}
               className={classNames(classes.name, {[classes.rootPanel]: root})}
            >
               {name}
            </Typography>
         ) : null}

         <IconButton onClick={toggle} className={classes.expandButton} size="large">
            {advanceExpanded ? <ExpandLess /> : <ExpandMore />}
         </IconButton>

         <Collapse in={advanceExpanded}>{children}</Collapse>
      </Paper>
   );
};

export default CollapsiblePanel;
